define('components/background-theme-selection-component/collections/theme-collection',[
    "components/background-theme-selection-component/models/single-theme-selection-author"
], function(ThemeModelClass) {
    "use strict";
    return Backbone.Collection.extend({
        "model": ThemeModelClass
    });
});

